import { TypeOf, yup } from '@guiker/shared-framework'

import { accountHolderTypeSchema } from './account-holder-type'

export const updateAccountHolderTypeSchema = yup.object({
  accountHolderType: accountHolderTypeSchema.required(),
})

export type UpdateAccountHolderTypeSchema = TypeOf<typeof updateAccountHolderTypeSchema>
